import type { ModelGradeBodyTypeIdsType } from "../../../common-deprecated/features/compare/utils/newCarCompareTypes";

export const spaceAndRoomCategoryCodes: string[] = ["DIMWGHT", "LOADCAP", "INTDIM"]; // ids are forced to uppercase before checking
export const engineCategoryCodes: string[] = ["ENVPERF", "ENG", "TRANS", "PERF", "WEIGHTTOW"]; // ids are forced to uppercase before checking

export const emptySelectedCarIds: ModelGradeBodyTypeIdsType = {
    model: "",
    gradeId: "",
    bodyTypeId: "",
    submodelId: "",
};
